import React from 'react';
import { formatNumber } from '../../utils/constants';

export const PayablesTab = ({ payables, payablesTotal }) => {
  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Accounts Payable (Outstanding Bills)</h3>
      <p className="text-sm text-muted-foreground mb-4">Purchases and expenses that have not been fully paid appear here as payables.</p>
      {payables.items?.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="w-full" data-testid="payables-table">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Reference</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Type</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-muted-foreground">Description</th>
                <th className="text-right py-3 px-4 text-sm font-medium text-muted-foreground">Amount Due</th>
              </tr>
            </thead>
            <tbody>
              {payables.items.map((item, index) => (
                <tr key={item.id || index} className="border-b border-border hover:bg-muted/30">
                  <td className="py-3 px-4 font-mono text-sm">{item.reference_id?.slice(0, 8) || '-'}...</td>
                  <td className="py-3 px-4 capitalize">{item.reference_type || item.type || 'other'}</td>
                  <td className="py-3 px-4 text-muted-foreground">{item.description || item.supplier_name || '-'}</td>
                  <td className="py-3 px-4 text-right font-semibold text-amber-600">{formatNumber(item.amount)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-muted/30 font-semibold">
                <td colSpan={3} className="py-3 px-4">Total Payables</td>
                <td className="py-3 px-4 text-right text-amber-600">RWF {formatNumber(payablesTotal)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <p className="text-center text-muted-foreground py-8">No outstanding payables. All bills have been paid.</p>
      )}
    </div>
  );
};
